import React from "react";

import { IProfile } from "../interface";
import * as S from "../styles";
import ModalLevels from "./ModalLevels";

const ModalSelectProfile: React.FC<{
  profiles: IProfile[];
  selected: {
    title: string;
    profileName: string;
    id: number;
  } | null;
  setShowSelector: (show: boolean) => void;
  handleSelectProfile: (profile: any) => void;
}> = ({ profiles, selected, handleSelectProfile, setShowSelector }) => {
  return (
    <S.ListContainer>
      {profiles.map((item, index) =>
        item && item?.active ? (
          <ModalLevels
            key={"item_" + index}
            handleSelectProfile={handleSelectProfile}
            item={item}
            selected={selected}
            setShowSelector={setShowSelector}
          />
        ) : null,
      )}
    </S.ListContainer>
  );
};

export default ModalSelectProfile;
